// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2IFa2","right":"Footer_right__qXaIT","buttons":"Footer_buttons__56FSt"};